import { getCurrency } from "locale-currency";

export const getCurrencySymbol = (locale = "en-US") => {
  const currency = getCurrency(locale) || "USD";

  const symbol = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  })
    .formatToParts(0)
    .find(p => p.type === "currency")?.value || "$";

  return `${symbol} `;
};

export const formatTaxPercent = (percent) =>
  parseFloat(Number(percent).toFixed(2));

export const formatAmount = (amount) =>
  Number(Number(amount).toFixed(2));
